// extracted by mini-css-extract-plugin
export var center = "_a-2";
export var clickableRow = "_a-5";
export var expandedRow = "_a-7";
export var hoverable = "_a-4";
export var left = "_a-1";
export var right = "_a-3";
export var row = "_a-0";
export var selectedRow = "_a-6";
export var summaryRow = "_a-8";